import { PrimaryButton } from '../PrimaryButton'
import Button from 'antd/lib/button'
import DoneIcon from '@mui/icons-material/Done'
import { useState } from 'react'
import RefreshIcon from '@mui/icons-material/Refresh'
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined'
import { useContext } from 'react'
import { SeekerContext } from '@/context/SeekerContext'
function DownloadLinkSentSuccess({
  setModalOpen = () => {},
  setIsSent = () => {},
  number = '',
  sendLink = () => {},
  showToastHandler
}) {
  const [text, setText] = useState(
    'https://play.google.com/store/apps/details?id=get.lokal.localjobs&hl=en_IN'
  )
  const [copied, setCopied] = useState(false)
  const { showCopyToast: toast, setShowCopyToast: setToast } = useContext(SeekerContext)

  const handleCopy = async (handler) => {
    try {
      await navigator.clipboard.writeText(text)
      setCopied(true)
      setToast((p) => {
        return {
          ...p,
          isVisible: !p.isVisible
        }
      })
      setTimeout(() => {
        setCopied(false), setToast(false)
      }, 2000) // Reset copied status after 2 seconds
    } catch (err) {
      console.error('Failed to copy: ', err)
    }
  }
  return (
    <div>
      <div className="ml-[24px]">
        <DoneIcon sx={{ color: '#0174D3' }} />
      </div>

      <div id="head" className="px-[24px]">
        <h3 className="font-noto-sans text-[28px] font-[600] text-greyTitleBase900">
          Download link sent by SMS to {number}
        </h3>
        <p className="text-[16px] font-[400] text-greyTertiaryBase500">
          Click the link on the message to download the app from Google Play.
        </p>
        <PrimaryButton
          title={'Okay'}
          onClick={() => {
            setIsSent(false)
            setModalOpen(false)
          }}
        />
      </div>
      <div id="footer" className="footer-gradient p-[24px]">
        <h3 className="font-noto-sans text-[16px] leading-[24px] text-greyTitleBase900 text-[600]">
          Didn’t receive the download link?
        </h3>
        <div className="flex w-[100%]">
          <Button
            className="btn-border flex w-[100%] items-center justify-center gap-[5px] bg-transparent py-[18px] font-noto-sans text-greyTitleBase900"
            onClick={() => {
              setIsSent(false)
              sendLink(number)
              setModalOpen(false)
            }}
          >
            {' '}
            <RefreshIcon sx={{ width: '18px', height: '18px' }} /> <span>Send Link Again</span>
          </Button>
          <Button
            className="btn-border ml-[16px] flex w-[100%] items-center justify-center gap-[9px] bg-transparent py-[18px] font-noto-sans text-greyTitleBase900"
            onClick={() => handleCopy(showToastHandler)}
          >
            {' '}
            <ContentCopyOutlinedIcon sx={{ width: '18px', height: '18px' }} />
            <span>Copy Link</span>
          </Button>
        </div>
      </div>
    </div>
  )
}

export default DownloadLinkSentSuccess
